import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ButterPageType } from '@app/content/models';
import { butterPageResolver } from '@app/content/resolvers';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./layout/components/default-layout/default-layout.component').then((c) => c.DefaultLayoutComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('./home/home.routes').then(({ routes }) => routes),
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/components/blank-layout/blank-layout.component').then((c) => c.BlankLayoutComponent),
    children: [
      {
        path: '',
        loadChildren: () => import('./auth/auth.routes').then(({ routes }) => routes),
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/components/default-layout/default-layout.component').then((c) => c.DefaultLayoutComponent),
    children: [
      {
        path: 'para-teqvoly',
        loadChildren: () => import('./para-teqvoly/para-teqvoly.routes').then(({ routes }) => routes),
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.routes').then(({ routes }) => routes),
      },
      {
        path: 'events',
        loadChildren: () => import('./events/events.routes').then(({ routes }) => routes),
      },
      {
        path: 'news',
        loadChildren: () => import('./news/news.routes').then(({ routes }) => routes),
      },
      {
        path: 'education',
        loadChildren: () => import('./education/education.routes').then(({ routes }) => routes),
      },
      {
        path: 'contact',
        loadChildren: () => import('./contact/contact.routes').then(({ routes }) => routes),
      },
      {
        path: 'documents',
        loadChildren: () => import('./documents/documents.routes').then(({ routes }) => routes),
      },
      {
        path: 'national-federation',
        loadChildren: () => import('./national-federation/national-federation.routes').then(({ routes }) => routes),
      },
      {
        path: 'partners-and-members',
        loadComponent: () =>
          import('./partners/components/members-page/members-page.component').then((c) => c.MembersPageComponent),
      },
      {
        path: 'verify-email/:email/:token',
        loadComponent: () =>
          import('./auth/components/verify-email-page/verify-email-page.component').then(
            (c) => c.VerifyEmailPageComponent
          ),
      },
      {
        path: '',
        loadChildren: () => import('./content/content.routes').then(({ routes }) => routes),
      },
      {
        path: ':slug',
        loadComponent: () =>
          import('./content/components/butter-site-page/butter-site-page.component').then(
            (c) => c.ButterSitePageComponent
          ),
        resolve: {
          page: butterPageResolver,
        },
        data: {
          pageType: ButterPageType.DEFAULT,
        },
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      paramsInheritanceStrategy: 'always',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
